/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Find_GroupInputs */

const en_header_find_group = /** @type {(inputs: Header_Find_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find your local group`)
};

/**
* | output |
* | --- |
* | "Find your local group" |
*
* @param {Header_Find_GroupInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const header_find_group = /** @type {((inputs?: Header_Find_GroupInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Find_GroupInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_find_group(inputs)
});